// Translations specific to service detail pages
export const tService = {
  back: { es: "← Volver a servicios", en: "← Back to services", jp: "← サービス一覧へ" },
  from: { es: "Inversión desde", en: "Investment from", jp: "料金" },
  mxn: { es: "MXN", en: "MXN", jp: "MXN" },
  book_cta: { es: "Reservar este servicio", en: "Book this service", jp: "この内容で予約" },
  process_title: { es: "Cómo trabajamos", en: "How we work", jp: "プロセス" },
  includes_title: { es: "Qué incluye", en: "What's included", jp: "含まれるもの" },
  gallery_title: { es: "Trabajo seleccionado", en: "Selected work", jp: "作品事例" },
  faq_title: { es: "Preguntas frecuentes", en: "Frequently asked questions", jp: "よくあるご質問" },
  related: { es: "Otros servicios", en: "Other services", jp: "その他のサービス" },
  cta_block: {
    es: { title: "¿Listas para hablar?", sub: "Cuéntame sobre tu evento. Respondo en menos de 24 horas." },
    en: { title: "Ready to talk?", sub: "Tell me about your event. I reply within 24 hours." },
    jp: { title: "ご相談はこちらから", sub: "イベントの詳細をお聞かせください。24時間以内にご返信します。" },
  },
};
